<div id="pricing-package-edit-dialog" class="pricing-package-edit-dialog">
    <mat-dialog-content class="d-flex flex-row flex-wrap align-items-start justify-content-start p-3 gap-2">
        <mat-form-field appearance="fill">
            <mat-label>Name</mat-label>
            <input
                matInput
                [(ngModel)]="pricingPackage().name"
                (ngModelChange)="onPackageUpdated()"
                required
                minlength="3"
                maxlength="128"
            />
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Status</mat-label>
            <mat-select name="status" [(ngModel)]="pricingPackage().type" required (ngModelChange)="onPackageUpdated()">
                @for (type of pricingPackageTypes; track type) {
                    <mat-option [value]="type">{{ type | pricingPackageType }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-checkbox [(ngModel)]="pricingPackage().isHidden" (ngModelChange)="onPackageUpdated()"
            >Is Hidden</mat-checkbox
        >

        <mat-checkbox [(ngModel)]="pricingPackage().isMarketplaceAvailable" (ngModelChange)="onPackageUpdated()"
            >Is Marketplace Available</mat-checkbox
        >

        <mat-checkbox [(ngModel)]="pricingPackage().areStandardListsAvailable" (ngModelChange)="onPackageUpdated()"
            >Are Standard Lists Available</mat-checkbox
        >

        <mat-form-field appearance="fill">
            <mat-label>External Id</mat-label>
            <input matInput [(ngModel)]="pricingPackage().externalId" (ngModelChange)="onPackageUpdated()" />
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Description</mat-label>
            <input matInput [(ngModel)]="pricingPackage().description" (ngModelChange)="onPackageUpdated()" />
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Comment</mat-label>
            <textarea matInput [(ngModel)]="pricingPackage().comment" (ngModelChange)="onPackageUpdated()"></textarea>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>connectedBrokerAccountsLimit</mat-label>
            <input
                matInput
                type="number"
                [(ngModel)]="pricingPackage().connectedBrokerAccountsLimit"
                (ngModelChange)="onPackageUpdated()"
            />
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>botsPerBrokerAccountLimit</mat-label>
            <input
                matInput
                type="number"
                [(ngModel)]="pricingPackage().botsPerBrokerAccountLimit"
                (ngModelChange)="onPackageUpdated()"
            />
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>testRunsPerDayLimit</mat-label>
            <input
                matInput
                type="number"
                [(ngModel)]="pricingPackage().testRunsPerDayLimit"
                (ngModelChange)="onPackageUpdated()"
            />
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>assetsPerTestRunLimit</mat-label>
            <input
                matInput
                type="number"
                [(ngModel)]="pricingPackage().assetsPerTestRunLimit"
                (ngModelChange)="onPackageUpdated()"
            />
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>activeBotsLimit</mat-label>
            <input
                matInput
                type="number"
                [(ngModel)]="pricingPackage().activeBotsLimit"
                (ngModelChange)="onPackageUpdated()"
            />
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>customListsCountLimit</mat-label>
            <input
                matInput
                type="number"
                [(ngModel)]="pricingPackage().customListsCountLimit"
                (ngModelChange)="onPackageUpdated()"
            />
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>customListLengthLimit</mat-label>
            <input
                matInput
                type="number"
                [(ngModel)]="pricingPackage().customListLengthLimit"
                (ngModelChange)="onPackageUpdated()"
            />
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>conditionalOrdersLimit</mat-label>
            <input
                matInput
                type="number"
                [(ngModel)]="pricingPackage().conditionalOrdersLimit"
                (ngModelChange)="onPackageUpdated()"
            />
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>botRunsPerDayLimit</mat-label>
            <input
                matInput
                type="number"
                [(ngModel)]="pricingPackage().botRunsPerDayLimit"
                (ngModelChange)="onPackageUpdated()"
            />
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>instantRunsPerDayLimit</mat-label>
            <input
                matInput
                type="number"
                [(ngModel)]="pricingPackage().instantRunsPerDayLimit"
                (ngModelChange)="onPackageUpdated()"
            />
        </mat-form-field>

        <mat-checkbox
            [(ngModel)]="pricingPackage().isWhiteHatBotsPaperAccountAvailable"
            (ngModelChange)="onPackageUpdated()"
            >Is White Hat Bots Paper Account Available</mat-checkbox
        >

        <mat-checkbox [(ngModel)]="pricingPackage().isAlpacaLiveAccountAvailable" (ngModelChange)="onPackageUpdated()"
            >Is Alpaca Live Account Available</mat-checkbox
        >

        <mat-checkbox [(ngModel)]="pricingPackage().isAlpacaPaperAccountAvailable" (ngModelChange)="onPackageUpdated()"
            >Is Alpaca Paper Account Available</mat-checkbox
        >

        <mat-checkbox [(ngModel)]="pricingPackage().isWebullLiveAccountAvailable" (ngModelChange)="onPackageUpdated()"
            >Is Webull Live Account Available</mat-checkbox
        >

        <mat-checkbox
            [(ngModel)]="pricingPackage().isWebullSandboxAccountAvailable"
            (ngModelChange)="onPackageUpdated()"
            >Is Webull Sandbox Account Available</mat-checkbox
        >

        <mat-checkbox
            [(ngModel)]="pricingPackage().isPublicLiveAccountAvailable"
            (ngModelChange)="onPackageUpdated()"
            >Is Public Live Account Available</mat-checkbox
        >

        <mat-checkbox
            [(ngModel)]="pricingPackage().isPublicSandboxAccountAvailable"
            (ngModelChange)="onPackageUpdated()"
            >Is Public Sandbox Account Available</mat-checkbox
        >
    </mat-dialog-content>

    <mat-dialog-actions align="center">
        @if (isNew()) {
            <button mat-stroked-button tabindex="-1" (click)="create()" [disabled]="!isComplete()">Create</button>
        }
        @if (!isNew()) {
            <button mat-stroked-button tabindex="-1" (click)="update()" [disabled]="!isComplete()">Update</button>
        }
        <button mat-stroked-button mat-dialog-close>Cancel</button>
    </mat-dialog-actions>
</div>
